import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { set } from "dot-prop-immutable";
import { Upload as DesignUpload, Button, message } from "@whalecloud/fdx";
import { getLocale } from "@utils/util";

const UploadElement = (props) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const {
    data: { formItemSettings = {}, settings = {}, className = "" } = {},
  } = element;
  const {
    buttonText = "",
    listType,
    fileList,
    fileSize,
    download,
    successMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT"],
    errorMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT"],
    errorSizeMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_ERROR_SIZE"],
    failMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT"],
    ...restProps
  } = formItemSettings;
  const { width } = settings;
  const typeList = formItemSettings?.accept?.split(",") || [];

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.map((file) => {
      if (info.file.status === "done") {
        // eslint-disable-next-line no-template-curly-in-string
        file.url = download.replace(
          "${id}",
          file.response[0][formItemSettings.fileIdName]
        );
      }
      return file;
    });
    if (info.file.status === "done") {
      message.success(successMessage);
    }
    if (info.file.status === "error") {
      message.error(failMessage);
    }
    const newElement = set(
      element,
      "data.formItemSettings.fileList",
      cloneDeep(fileList)
    );
    updateElement({
      element: newElement,
    });
  };

  //文件类型校验
  const checkType = (file, typeList) => {
    return new Promise(function(resolve, reject) {
      let res = false;
      if (typeList.length === 0 || typeList.includes("*")) {
        res = true;
      } else {
        typeList.forEach((type) => {
          if (type === file.type) {
            res = true;
          }
          if (type === "image/*" && file.type.includes("image")) {
            res = true;
          }
          if (type === "video/*" && file.type.includes("video")) {
            res = true;
          }
          if (type === "audio/*" && file.type.includes("audio")) {
            res = true;
          }
        });
      }
      if (res) {
        resolve();
      } else {
        message.error(errorMessage);
        reject();
      }
    });
  };

  //文件大小校验
  const checkSize = (file) => {
    return new Promise(function(resolve, reject) {
      let res = true;
      if( fileSize ) {
        const isLt2M = file.size / 1024 / 1024 < fileSize;
        res = isLt2M;
      }
      if (res) {
        resolve();
      } else {
        message.error( `${errorSizeMessage} ${fileSize}MB`);
        reject();
      }
    });
  };

  return (
    <DesignUpload
      listType={listType}
      download={download}
      fileList={fileList}
      {...restProps}
      className={className}
      style={{ width: width.value }}
      beforeUpload={(file, fileList) => {
        return Promise.all([checkType(file, [...typeList]), checkSize(file)]);
      }}
      onChange={handleChange}
    >
      {listType !== "picture-card" ? (
        <Button icon="folder">{buttonText}</Button>
      ) : null}
    </DesignUpload>
  );
};

export default UploadElement;
